/* mo-sale-board.js, part 1 of 2: the receipt printer (2026-10-07). After "Receipt Printer", 21st.dev id 31601.
   window.MOSaleReceipt.mount(rootEl, { onLine(id, li), push }) -> { print, reprint, expand, collapse, tear, destroy }

   The lines are already in the HTML. This file only reveals them: a clip on the paper grows one row at a
   time and the printer bar rides its edge. It writes transform, clip-path and opacity, reads sizes once
   per print, runs on one requestAnimationFrame loop, and has no timer. Off screen or in a hidden tab it
   finishes whatever was running and stops.
   push (optional): the elements that follow the printer, or a function that returns them. They are
   carried along by transform while the paper grows or rolls back, so the page looks pushed although
   the layout changed once, at the click. */
(function (w, d) {
  'use strict';

  var PAD = 60;       // the clip reaches this far past the paper, for the curl and the shadow
  var CURL_AT = 48;   // px of paper out before the free end curls
  var LEAD = 120;     // ms the printer waits before the first row
  var FONT_WAIT = 1200; // ms the first print will wait for web fonts
  var HOME = 220;     // ms for the printer to return to the top after a tear
  var FALL = 620;     // ms the torn sheet takes to fall and fade
  var G = 1500;       // px per second squared
  var TEAR_X = 72, TEAR_UP = 60, SLOP = 8;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function inOut(p) { return p < .5 ? 2 * p * p : 1 - 2 * (1 - p) * (1 - p); }
  function out3(p) { p = 1 - p; return 1 - p * p * p; }
  function back(p) { p -= 1; return 1 + 2 * p * p * p + p * p; }   // lands about 4% long, then settles
  function el(tag, cls, text) { var n = d.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function pose(x, y, r) { return x || y || r ? 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(' + r.toFixed(2) + 'deg)' : ''; }
  function strip(n) {
    for (var i = n.attributes.length - 1, a; i >= 0; i--) {
      a = n.attributes[i].name;
      if (!a.indexOf('data-') || a === 'href' || a === 'id' || a === 'style') n.removeAttribute(a);
    }
  }
  /* the torn sheet's outline: open above and at the sides, a zigzag along the tear */
  function torn(W, H) {
    var n = Math.max(8, Math.round(W / 7)), pts = [-PAD + 'px ' + -PAD + 'px', (W + PAD) + 'px ' + -PAD + 'px', (W + PAD) + 'px ' + H + 'px'], i;
    for (i = n; i >= 0; i--) pts.push((W * i / n).toFixed(1) + 'px ' + (H - (i % 2 ? 0 : 3)) + 'px');
    pts.push(-PAD + 'px ' + H + 'px');
    return 'polygon(' + pts.join(',') + ')';
  }

  function mount(root, opts) {
    opts = opts || {};
    var paper = root.querySelector('[data-paper]'), bar = root.querySelector('[data-bar]'), list = root.querySelector('[data-r-lines]');
    if (!paper || !bar || !list) return null;
    var inner = list.parentNode, more = root.querySelector('[data-r-more]');
    var push = [];
    /* what follows the printer depends on the layout (under it on a phone, beside it on a wide screen) */
    function followers() { var p = typeof opts.push === 'function' ? opts.push() : opts.push; push = !p ? [] : p.nodeType ? [p] : [].slice.call(p); }
    var mq = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var moreHTML = more ? more.innerHTML : '', lessLabel = (more && more.getAttribute('data-r-less')) || 'Roll it back';
    var ruleEl = list.querySelector('.mo-sale__r-rule'), ruleLabel = list.getAttribute('data-r-rule') || (ruleEl && ruleEl.textContent) || 'Price only';
    var countEl = root.querySelector('[data-r-count]'), count = countEl ? countEl.textContent : '';
    var anim = null, ghosts = [], raf = 0, drag = null, swallow = false, armed = false, dead = false;
    var onScreen = !('IntersectionObserver' in w), fontsReady = !(d.fonts && d.fonts.ready), lastW = w.innerWidth, io = null;

    function still() { return !!(mq && mq.matches); }
    function collapsed() { return root.hasAttribute('data-collapsed'); }

    /* ---- the three things the script writes ---- */
    function clip(y, H) {
      paper.style.clipPath = y <= 0 ? 'inset(0 0 100% 0)' : 'inset(' + -Math.min(PAD, y).toFixed(1) + 'px ' + -PAD + 'px ' + (H - y).toFixed(1) + 'px ' + -PAD + 'px)';
    }
    function slide(node, dy) { node.style.transform = dy ? 'translate3d(0,' + dy.toFixed(1) + 'px,0)' : ''; }
    function carry(dy) { for (var i = 0; i < push.length; i++) slide(push[i], dy); }
    function jump(y) { try { w.scrollTo({ top: y, left: w.pageXOffset, behavior: 'instant' }); } catch (e) { w.scrollTo(w.pageXOffset, y); } }
    function rest() {
      paper.style.clipPath = ''; paper.style.transform = ''; bar.style.transform = ''; carry(0);
      root.removeAttribute('data-flat'); root.removeAttribute('data-state');
    }

    /* ---- sizes, read in one pass: the paper, and the bottom of every row that is laid out ---- */
    function read() {
      var pr = paper.getBoundingClientRect(), rr = root.getBoundingClientRect(), stops = [], kids = inner.children, i, j, row, r;
      for (i = 0; i < kids.length; i++) {
        row = kids[i] === list ? list.children : [kids[i]];
        for (j = 0; j < row.length; j++) { r = row[j].getBoundingClientRect(); if (r.height) stops.push(r.bottom - pr.top); }
      }
      stops[Math.max(0, stops.length - 1)] = pr.height;
      return { H: pr.height, W: pr.width, x: pr.left - rr.left, y: pr.top - rr.top, top: rr.top, stops: stops };
    }

    /* ---- one loop ---- */
    function run(a) { anim = a; if (!raf) raf = w.requestAnimationFrame(frame); }
    function frame(now) {
      raf = 0;
      var live = false, a, i;
      if (anim && !anim.tick(now)) { a = anim; anim = null; a.end(); }
      for (i = ghosts.length - 1; i >= 0; i--) { if (fall(ghosts[i], now)) live = true; else drop(i); }
      if (anim || live) raf = w.requestAnimationFrame(frame);
    }
    /* finish whatever is running, now. end() comes last: it may start the wait for the first print again. */
    function settle() {
      var a = anim;
      anim = null;
      if (raf) { w.cancelAnimationFrame(raf); raf = 0; }
      while (ghosts.length) drop(0);
      if (drag) letGo();
      paper.style.transform = '';
      if (a) a.end();
    }

    /* ---- print what the current state shows, from the top. homeFrom: where the bar starts its return ---- */
    function print(homeFrom) {
      armed = false;
      root.removeAttribute('data-armed');
      root.setAttribute('data-flat', '');
      var m = read(), step = m.stops.length > 14 ? 55 : 64, home = homeFrom > 0 ? HOME : 0, t0 = 0, hot = !home, curled = false;
      clip(0, m.H);
      slide(bar, (home ? homeFrom : 0) - m.H);
      root.setAttribute('data-state', home ? 'homing' : 'printing');
      run({
        tick: function (now) {
          if (!t0) t0 = now;
          var e = now - t0, k, a, y;
          if (e < home) { slide(bar, homeFrom * (1 - inOut(e / home)) - m.H); return true; }
          if (!hot) { hot = true; root.setAttribute('data-state', 'printing'); }
          e -= home + LEAD;
          if (e < 0) { slide(bar, -m.H); return true; }
          k = Math.floor(e / step);
          if (k >= m.stops.length) return false;
          a = k ? m.stops[k - 1] : 0;
          y = a + (m.stops[k] - a) * back(Math.min(1, (e - k * step) / (step * .62)));
          clip(y, m.H);
          slide(bar, y - m.H);
          if (!curled && y > CURL_AT) { curled = true; root.removeAttribute('data-flat'); }
          return true;
        },
        end: rest
      });
    }
    /* the first print: once it is on screen and the type has loaded. A slow font holds it for FONT_WAIT at most. */
    function first() {
      if (!armed || !onScreen || anim || d.hidden || dead) return;
      if (fontsReady) { print(0); return; }
      var t0 = 0, late = false;
      run({
        tick: function (now) { if (!t0) t0 = now; late = now - t0 >= FONT_WAIT; return !fontsReady && !late; },
        end: function () { if (late) fontsReady = true; first(); }
      });
    }

    /* ---- Print all: the layout grows once, here; then the rest prints and the bar travels down ---- */
    function label(open) {
      if (!more) return;
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) more.textContent = lessLabel; else { more.innerHTML = moreHTML; set('[data-r-total]', count); }
    }
    function expand() {
      if (!collapsed()) return;
      settle();
      followers();
      var h0 = paper.offsetHeight, m, k0 = 0, t0 = 0;
      root.removeAttribute('data-collapsed');
      label(true);
      if (armed) { first(); return; }
      if (still() || !onScreen) return;
      m = read();
      while (k0 < m.stops.length - 1 && m.stops[k0] <= h0 + 1) k0++;
      clip(h0, m.H); slide(bar, h0 - m.H); carry(h0 - m.H);
      root.setAttribute('data-state', 'printing');
      run({
        tick: function (now) {
          if (!t0) t0 = now;
          var e = now - t0 - 40, k, a, y;
          if (e < 0) return true;
          k = k0 + Math.floor(e / 55);
          if (k >= m.stops.length) return false;
          a = k > k0 ? m.stops[k - 1] : h0;
          y = a + (m.stops[k] - a) * back(Math.min(1, (e - (k - k0) * 55) / 34));
          clip(y, m.H); slide(bar, y - m.H); carry(y - m.H);
          return true;
        },
        end: rest
      });
    }
    /* ---- Roll it back: the paper rewinds into the printer, then the layout shrinks once.
            If the top of the receipt is above the window, the page scrolls up with the rewind until it shows. ---- */
    function collapse() {
      if (collapsed()) return;
      settle();
      followers();
      var m = read(), inset = parseFloat(w.getComputedStyle(root).scrollMarginTop) || 0, sy = w.pageYOffset, h0, dist, sc, dur, t0 = 0, home = false;
      root.setAttribute('data-collapsed', '');
      label(false);
      if (armed) return;
      if (still() || !onScreen) { if (onScreen && m.top < inset) jump(sy + m.top - inset); return; }
      h0 = paper.offsetHeight;
      root.removeAttribute('data-collapsed');
      dist = m.H - h0;
      sc = clamp(inset - m.top, 0, sy);
      dur = clamp(170 + dist * .2, 200, 340);
      root.setAttribute('data-state', 'rolling');
      run({
        tick: function (now) {
          if (!t0) t0 = now;
          var p = (now - t0) / dur, y;
          if (p >= 1) { if (home) return false; home = true; p = 1; }   // draw the last frame exactly, swap the layout on the next
          p = inOut(p);
          y = m.H - dist * p;
          clip(y, m.H); slide(bar, y - m.H); carry(y - m.H);
          if (sc) jump(sy - sc * p);
          return true;
        },
        end: function () { root.setAttribute('data-collapsed', ''); rest(); if (sc) jump(sy - sc); }
      });
    }

    /* ---- tear: a copy of the sheet falls away while the printer starts over ---- */
    function ghost(m, dir, from) {
      var g = paper.cloneNode(true), all = g.querySelectorAll('*'), box = el('div', 'mo-sale__torn'), i;
      strip(g);
      for (i = 0; i < all.length; i++) strip(all[i]);
      g.className += ' mo-sale__paper--torn';
      g.style.clipPath = torn(m.W, m.H);
      box.setAttribute('aria-hidden', 'true');
      box.setAttribute('inert', '');
      box.style.cssText = 'top:' + m.y.toFixed(1) + 'px;left:' + m.x.toFixed(1) + 'px;width:' + m.W.toFixed(1) + 'px';
      if (from) box.style.transform = pose(from.x, from.y, from.r);
      box.appendChild(g);
      root.appendChild(box);
      ghosts.push({ el: box, t0: 0, dir: dir, k: m.W < 420 ? .45 : 1, x: from ? from.x : 0, y: from ? from.y : 0, r: from ? from.r : 0 });
    }
    function fall(g, now) {
      if (!g.t0) g.t0 = now;
      var t = (now - g.t0) / 1000, p = t * 1000 / FALL;
      if (p >= 1) return false;
      g.el.style.transform = pose(g.x + g.dir * g.k * (30 * t + 70 * t * t), g.y + 6 * Math.min(1, p * 8) + .5 * G * t * t, g.r + g.dir * g.k * (.8 + 9 * t));
      g.el.style.opacity = p < .42 ? '' : (1 - (p - .42) / .58).toFixed(3);
      return true;
    }
    function drop(i) { var g = ghosts.splice(i, 1)[0]; if (g.el.parentNode) g.el.parentNode.removeChild(g.el); }
    function swap() {
      if (!onScreen) return;
      root.removeAttribute('data-swap');
      void paper.offsetWidth;
      root.setAttribute('data-swap', '');
    }
    function tear(dir, from, lines, meta) {
      settle();
      if (armed) { if (lines) fill(lines, meta); return; }
      if (still() || !onScreen || d.hidden) { if (lines) fill(lines, meta); swap(); return; }
      var m = read();
      ghost(m, dir || 1, from);
      if (lines) fill(lines, meta);
      print(m.H);
    }

    /* ---- a new list (the size changed) ---- */
    function set(sel, v) { for (var n = root.querySelectorAll(sel), i = 0; i < n.length; i++) n[i].textContent = v; }
    function fill(lines, meta) {
      var f = d.createDocumentFragment(), ruled = false, i, l, li, a, nm, cmp;
      for (i = 0; i < lines.length; i++) {
        l = lines[i];
        if (l.plain && !ruled) { ruled = true; li = el('li', 'mo-sale__r-rule', ruleLabel); li.setAttribute('aria-hidden', 'true'); f.appendChild(li); }
        li = el('li', 'mo-sale__r-line' + (l.plain ? ' mo-sale__r-line--plain' : ''));
        li.setAttribute('data-r-line', '');
        li.setAttribute('data-id', l.id);
        if (!l.plain) li.setAttribute('data-diff', l.diffCents != null ? l.diffCents : Math.round(parseFloat(String(l.diff).replace(/[^0-9.]/g, '')) * 100) || 0);
        a = el('a');
        a.setAttribute('href', '#mo-sale-card-' + l.id);
        nm = el('span', 'mo-sale__r-name');
        nm.appendChild(el('b', '', l.brand));
        nm.appendChild(d.createTextNode(' ' + l.name));
        a.appendChild(nm);
        a.appendChild(el('span', 'visually-hidden', ', price '));
        a.appendChild(el('span', 'mo-sale__r-now', l.now));
        cmp = el('span', 'mo-sale__r-cmp');
        if (l.was) { cmp.appendChild(el('span', 'visually-hidden', ', ')); cmp.appendChild(el('span', 'mo-sale__r-label', l.label || 'Compare at')); cmp.appendChild(d.createTextNode(' ')); cmp.appendChild(el('s', 'mo-sale__r-was', l.was)); }
        a.appendChild(cmp);
        a.appendChild(el('span', 'visually-hidden', l.diff ? ', difference ' : ''));
        a.appendChild(el('span', 'mo-sale__r-diff', l.diff || ''));
        li.appendChild(a);
        f.appendChild(li);
      }
      var held = list.contains(d.activeElement) && d.activeElement.closest ? d.activeElement.closest('[data-r-line]') : null, heldId = held && held.getAttribute('data-id'), again;
      list.textContent = '';
      list.appendChild(f);
      if (held) { again = list.querySelector('[data-r-line][data-id="' + heldId + '"] a') || list.querySelector('[data-r-line] a'); if (again) again.focus({ preventScroll: true }); }
      if (meta) {
        count = meta.count;
        set('[data-r-size]', meta.size); set('[data-r-count]', meta.count); set('[data-r-foot]', meta.foot); set('[data-r-total]', meta.count);
        if (meta.word) set('[data-r-word]', meta.word);
      }
      fit();
    }
    /* a list that fits on the collapsed sheet is shown whole, footer included, with no "Print all" */
    function fit() {
      var wasShort = root.hasAttribute('data-short'), kids = list.children, hides = false, i;
      if (!collapsed() && !wasShort) return;      /* opened by the shopper: it stays open */
      root.setAttribute('data-collapsed', ''); root.removeAttribute('data-short');
      for (i = kids.length - 1; i >= 0 && !hides; i--) hides = w.getComputedStyle(kids[i]).display === 'none';
      if (!hides) { root.removeAttribute('data-collapsed'); root.setAttribute('data-short', ''); }
      else if (wasShort) label(false);
    }

    /* ---- pulling the paper sideways or up tears it ---- */
    function grip(x, y) { return { x: x * .42, y: y < 0 ? y * .3 : y * .06, r: x * .022 }; }
    function letGo() {
      w.removeEventListener('pointermove', onMove);
      w.removeEventListener('pointerup', onUp);
      w.removeEventListener('pointercancel', onUp);
      if (drag && drag.on) {
        root.removeAttribute('data-dragging');
        try { paper.releasePointerCapture(drag.id); } catch (e) {}
      }
      drag = null;
    }
    function onDown(e) {
      swallow = false;
      if (e.button || !e.isPrimary || anim || drag || armed || still()) return;
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, dx: 0, dy: 0, on: false, touch: e.pointerType === 'touch' };
      w.addEventListener('pointermove', onMove);
      w.addEventListener('pointerup', onUp);
      w.addEventListener('pointercancel', onUp);
    }
    function onMove(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y, g, s;
      if (!drag.on) {
        if (Math.abs(dx) < SLOP && Math.abs(dy) < SLOP) return;
        if (drag.touch && Math.abs(dy) > Math.abs(dx)) { letGo(); return; }   // a vertical swipe is a scroll
        drag.on = swallow = true;
        root.setAttribute('data-dragging', '');
        try { paper.setPointerCapture(drag.id); } catch (err) {}
        s = w.getSelection && w.getSelection();
        if (s && s.removeAllRanges) s.removeAllRanges();
      }
      drag.dx = dx; drag.dy = dy;
      g = grip(dx, dy);
      if (Math.abs(dx) >= TEAR_X || dy <= -TEAR_UP) { letGo(); tear(dx < 0 ? -1 : 1, g); return; }
      paper.style.transform = pose(g.x, g.y, g.r);
    }
    function onUp(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var g = drag.on ? grip(drag.dx, drag.dy) : null, t0 = 0;
      letGo();
      if (!g) return;
      run({   // not far enough: the paper springs back
        tick: function (now) {
          if (!t0) t0 = now;
          var q = (now - t0) / 170;
          if (q >= 1) return false;
          q = 1 - out3(q);
          paper.style.transform = pose(g.x * q, g.y * q, g.r * q);
          return true;
        },
        end: function () { paper.style.transform = ''; }
      });
    }

    /* ---- controls, and the lines ---- */
    function onClick(e) {
      var t = e.target, a;
      if (!t.closest) return;
      if (t.closest('[data-r-more]')) { if (root.hasAttribute('data-short')) return; if (collapsed()) expand(); else collapse(); return; }
      if (t.closest('[data-r-tear]')) { tear(1); return; }
      if (!paper.contains(t)) return;
      if (swallow && e.detail) { swallow = false; e.preventDefault(); return; }   // the click that ends a pull
      a = t.closest('[data-r-line] a');
      if (a && opts.onLine) { e.preventDefault(); opts.onLine(a.parentNode.getAttribute('data-id'), a.parentNode); }
    }
    function onDragStart(e) { e.preventDefault(); }
    function onHide() { if (d.hidden) settle(); else first(); }
    function onResize() { if (w.innerWidth !== lastW) { lastW = w.innerWidth; settle(); } }
    function onSwapEnd(e) { if (e.target === paper) root.removeAttribute('data-swap'); }

    root.addEventListener('click', onClick);
    paper.addEventListener('pointerdown', onDown);
    paper.addEventListener('dragstart', onDragStart);
    paper.addEventListener('animationend', onSwapEnd);
    d.addEventListener('visibilitychange', onHide);
    w.addEventListener('resize', onResize);

    root.setAttribute('data-live', '');
    fit();
    if (!collapsed() && !root.hasAttribute('data-short')) label(true);
    if (still()) root.removeAttribute('data-armed'); else { armed = true; root.setAttribute('data-armed', ''); }
    /* wait for the type, and one frame more, so a late font never moves a row while it prints */
    if (!fontsReady) d.fonts.ready.then(function () { w.requestAnimationFrame(function () { fontsReady = true; first(); }); });
    if (!onScreen) {
      io = new w.IntersectionObserver(function (es) {
        var en = es[es.length - 1];
        onScreen = en.isIntersecting && (en.intersectionRatio >= .2 || en.intersectionRect.height >= 180);
        if (!en.isIntersecting) settle(); else if (onScreen) first();
      }, { threshold: [0, .2] });
      io.observe(root);
    } else first();

    return {
      /* print what is showing, from the top; off screen it waits until it is seen */
      print: function () {
        settle();
        if (still()) return;
        if (onScreen && !d.hidden) print(0); else { armed = true; root.setAttribute('data-armed', ''); }
      },
      /* lines = [{id, brand, name, now, was, diff, plain}], meta = {size, count, foot} */
      reprint: function (lines, meta) { tear(1, null, lines || [], meta); },
      expand: expand,
      collapse: collapse,
      refit: function () { if (!anim) fit(); },      /* the window or the line limit changed */
      tear: function () { tear(1); },
      destroy: function () {
        dead = true;
        settle();
        if (io) io.disconnect();
        root.removeEventListener('click', onClick);
        paper.removeEventListener('pointerdown', onDown);
        paper.removeEventListener('dragstart', onDragStart);
        paper.removeEventListener('animationend', onSwapEnd);
        d.removeEventListener('visibilitychange', onHide);
        w.removeEventListener('resize', onResize);
        rest();
        root.removeAttribute('data-armed'); root.removeAttribute('data-live'); root.removeAttribute('data-swap');
      }
    };
  }

  w.MOSaleReceipt = { mount: mount };
})(window, document);

/* mo-sale-board.js, part 2 of 2: the list behind sections/mo-sale-board.liquid (2026-10-07).
 * Vanilla JS, no library needed. The page is complete without this file: every row and every
 * receipt line is server-rendered for the default size. This adds the size picker (reprices every
 * row, re-sorts the list and reprints the receipt), the feel, brand, budget and floor filters, the
 * store wording on floor lines and per-size delivery dates.
 * Every figure comes from the variant JSON printed in each row. Nothing here holds a price.
 * Reduced motion: no rolling prices, no sliding rows, the receipt is shown printed. */
(function () {
  'use strict';
  if (window.MOSaleBoard) return;

  var still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var flowReady = false;

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function keys(value) { return (value || '').split(',').map(function (k) { return k.trim(); }).filter(Boolean); }
  /* same output as Liquid's money_without_trailing_zeros: cents only when there are any */
  function money(cents) {
    var whole = cents % 100 === 0;
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 });
  }
  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }

  /* ---------- stores (names and coordinates come from the header's data island) ---------- */
  var stores = {};
  function readStores() {
    var island = document.querySelector('[data-mo-showrooms]');
    if (!island) return;
    try { (JSON.parse(island.textContent).stores || []).forEach(function (s) { stores[s.key] = s; }); } catch (e) { /* keep defaults */ }
  }
  function storeName(key) {
    if (stores[key] && stores[key].name) return stores[key].name;
    if (key === 'nicholasville-road') return 'Lexington';
    return key ? key.charAt(0).toUpperCase() + key.slice(1) : '';
  }
  function selectedStore() { return document.documentElement.getAttribute('data-mo-selected-showroom') || ''; }
  function miles(a, b) {
    var rad = Math.PI / 180, dLat = (b.lat - a.lat) * rad, dLon = (b.lon - a.lon) * rad;
    var h = Math.pow(Math.sin(dLat / 2), 2) + Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.pow(Math.sin(dLon / 2), 2);
    return 3958.8 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  }
  function nearest(fromKey, candidates) {
    var from = stores[fromKey];
    if (!from) return candidates[0];
    return candidates.slice().sort(function (x, y) {
      return (stores[x] ? miles(from, stores[x]) : 1e9) - (stores[y] ? miles(from, stores[y]) : 1e9);
    })[0];
  }
  function spread(list) {
    if (list.length === 5) return 'at all five showrooms';
    return list.length === 1 ? 'at one showroom' : 'at ' + list.length + ' showrooms';
  }

  /* ---------- one board ---------- */
  function Board(root) {
    var state = { size: root.getAttribute('data-default-size') || 'Queen', feel: 'all', brand: 'all', budget: null, floorOnly: false };
    var list = root.querySelector('[data-sale-rows]');
    var controls = root.querySelector('[data-sale-controls]');
    var range = root.querySelector('[data-budget]');
    var restLabel = root.getAttribute('data-rest-label') || 'No difference to show';
    var restNote = root.getAttribute('data-rest-note') || '';
    var booted = false;

    var rows = all('[data-sale-row]', root).map(function (el, index) {
      var sizes = {};
      try { sizes = JSON.parse(el.querySelector('[data-sizes-json]').textContent); } catch (e) { /* no sizes */ }
      return {
        el: el, index: index, id: el.getAttribute('data-id'), brand: el.getAttribute('data-brand'),
        brandName: el.getAttribute('data-brand-name') || '', name: el.getAttribute('data-name') || '',
        feel: el.getAttribute('data-feel'), floor: keys(el.getAttribute('data-floor')),
        mode: el.getAttribute('data-mode') || 'difference', label: el.getAttribute('data-label') || '',
        sizes: sizes, buy: el.querySelector('[data-buy]'), slot: el.querySelector('[data-mo-eta]')
      };
    });

    /* what a row shows for the chosen size; "price" mode never shows a compare-at figure */
    function read(row) {
      var entry = row.sizes[state.size] || row.sizes['*'] || null;      /* "*": a product with no mattress size has one price */
      var ok = !!(entry && entry.ok);
      var struck = !!(entry && row.mode !== 'price' && entry.compare > entry.price);
      var diff = ok && struck && row.mode === 'difference' ? entry.compare - entry.price : 0; /* no difference on a size that cannot be bought */
      return { entry: entry, ok: ok, struck: struck, diff: diff, group: !ok ? 0 : diff > 0 ? 2 : 1 };
    }
    function onFloor(row) {
      var store = selectedStore();
      return row.floor.length > 0 && (!store || row.floor.indexOf(store) !== -1);
    }
    function passes(row, r) {
      if (state.feel !== 'all' && row.feel !== state.feel) return false;
      if (state.brand !== 'all' && row.brand !== state.brand) return false;
      if (state.floorOnly && !onFloor(row)) return false;
      if (state.budget !== null && (!r.entry || r.entry.price > state.budget * 100)) return false;
      return true;
    }

    /* The price rolls from the last size's figure to this one. Number Flow measures before and
       after each change, so the changes are queued and run in three passes (measure all, write
       all, measure all) on the next frame: two layouts for the whole list instead of one per row. */
    var rolling = [], rollFrame = 0;
    function roll() {
      rollFrame = 0;
      var jobs = rolling.filter(function (job) { return job.row.cents != null && job.flow.isConnected; });
      rolling = [];
      jobs.forEach(function (job) {
        var digits = job.row.cents % 100 ? 2 : 0;
        job.flow.format = { style: 'currency', currency: 'USD', minimumFractionDigits: digits, maximumFractionDigits: digits };
        job.flow.batched = true; job.flow.willUpdate();
      });
      jobs.forEach(function (job) { job.flow.update(job.row.cents / 100); });
      jobs.forEach(function (job) { job.flow.didUpdate(); job.flow.batched = false; });
    }
    function setPrice(row, host, entry) {
      var prev = row.cents;
      row.cents = entry ? entry.price : null;
      if (!entry || !flowReady || still) { setText(host, entry ? money(entry.price) : 'Not made in ' + state.size); return; }
      var flow = host.querySelector('number-flow');
      if (!flow) {
        if (prev == null || prev === entry.price) { setText(host, money(entry.price)); return; }
        host.textContent = '';
        flow = document.createElement('number-flow');
        flow.format = { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2 };
        flow.transformTiming = { duration: 550, easing: 'cubic-bezier(.2,.9,.3,1)' };
        host.appendChild(flow);
        flow.update(prev / 100);
      }
      rolling.push({ row: row, flow: flow });
      if (!rollFrame) rollFrame = requestAnimationFrame(roll);
    }

    function floorWording(row) {
      var line = row.el.querySelector('[data-mo-floor-line]');
      if (!line) return;
      var store = selectedStore(), label = line.querySelector('[data-mo-card-tryability-label]'), wrap = line.parentElement;
      if (!store || !stores[store]) {
        setText(label, 'On the floor ' + spread(row.floor));
        wrap.classList.add('is-yes');
      } else if (row.floor.indexOf(store) !== -1) {
        setText(label, 'On the floor in ' + storeName(store));
        if (stores[store].url && line.getAttribute('href') !== stores[store].url) line.setAttribute('href', stores[store].url);
        wrap.classList.add('is-yes');
      } else {
        var near = nearest(store, row.floor);
        setText(label, 'Not on the floor in ' + storeName(store) + '. Nearest is ' + storeName(near) + '.');
        if (stores[near] && stores[near].url && line.getAttribute('href') !== stores[near].url) line.setAttribute('href', stores[near].url);
        wrap.classList.remove('is-yes');
      }
    }

    /* The delivery slot is snippets/mo-eta-slot, read by assets/mo-eta.js, both unchanged. It shows
       the soonest date among the variant ids it carries, so it is handed the chosen size alone and
       put back in place; mo-eta.js sees a new slot and fills in that size's date, or hides it. */
    function aimEta(row, r) {
      var slot = row.slot;
      if (!slot) return;
      var id = r.ok ? String(r.entry.id) : '';
      if (slot.getAttribute('data-mo-eta-variants') === id) return;
      slot.setAttribute('data-mo-eta-variants', id);
      slot.classList.remove('is-ready');
      slot.setAttribute('hidden', '');
      slot.__kicks = 0;
      kick(slot);
    }
    function kick(slot) {
      var parent = slot.parentNode, next = slot.nextSibling;
      slot.removeAttribute('data-mo-eta-state');
      parent.removeChild(slot);
      parent.insertBefore(slot, next);
    }
    /* mo-eta.js marks a slot "pending" when it takes it up and "done" when its answer is in. If an
       answer for the previous size lands between the hand-off and mo-eta.js's next pass, the slot is
       marked done without ever being asked for this size. Seen here as "done" for ids that were
       never "pending": hand the slot over once more. */
    if ('MutationObserver' in window) {
      new MutationObserver(function (records) {
        records.forEach(function (rec) {
          var slot = rec.target, st = slot.getAttribute('data-mo-eta-state'), ids = slot.getAttribute('data-mo-eta-variants');
          if (st === 'pending') slot.__asked = ids;
          else if (st === 'done' && slot.__asked !== ids && (slot.__kicks || 0) < 2) { slot.__kicks = (slot.__kicks || 0) + 1; kick(slot); }
        });
      }).observe(list, { attributes: true, subtree: true, attributeFilter: ['data-mo-eta-state'] });
    }

    function divider(attr, cls, label, note) {
      var el = list.querySelector('[' + attr + ']');
      if (!el) {
        el = document.createElement('div');
        el.className = 'mo-sale__rule' + cls;
        el.setAttribute(attr, '');
        var h = document.createElement('h2'); el.appendChild(h);
        if (note) { var sp = document.createElement('span'); sp.textContent = note; el.appendChild(sp); }
      }
      setText(el.querySelector('h2'), label);
      return el;
    }

    /* rows slide to their new places (first, last, invert, play) */
    function reorder(sorted, ruleBefore, offBefore, offLabel) {
      var move = booted && !still && typeof list.animate === 'function';
      var before = {};
      if (move) rows.forEach(function (row) { if (!row.el.hidden) before[row.id] = row.el.getBoundingClientRect().top; });
      var mark = divider('data-sale-rule', '', restLabel, restNote), off = divider('data-sale-rule-off', ' mo-sale__rule--off', offLabel || '', ''), wanted = [];
      sorted.forEach(function (row) {
        if (row === ruleBefore) wanted.push(mark);
        if (row === offBefore) wanted.push(off);
        wanted.push(row.el);
      });
      if (!ruleBefore && mark.parentNode) mark.parentNode.removeChild(mark);
      if (!offBefore && off.parentNode) off.parentNode.removeChild(off);
      var current = Array.prototype.slice.call(list.children), same = current.length === wanted.length;
      for (var i = 0; same && i < wanted.length; i++) if (current[i] !== wanted[i]) same = false;
      if (!same) wanted.forEach(function (el) { list.appendChild(el); });
      if (!move) return;
      rows.forEach(function (row) {
        if (row.el.hidden || before[row.id] == null) return;
        var dy = before[row.id] - row.el.getBoundingClientRect().top;
        if (Math.abs(dy) < 2 || Math.abs(dy) > 2400) return;
        row.el.animate([{ transform: 'translateY(' + dy + 'px)' }, { transform: 'none' }], { duration: 460, easing: 'cubic-bezier(.2,.8,.2,1)' });
      });
    }

    function budgetBounds() {
      if (!range) return;
      var low = 0, high = 0;
      rows.forEach(function (row) {
        var e = row.sizes[state.size] || row.sizes['*'];
        if (!e) return;
        if (!low || e.price < low) low = e.price;
        if (e.price > high) high = e.price;
      });
      var min = Math.floor(low / 5000) * 50, top = Math.ceil(high / 5000) * 50, max = top + 50;
      if (String(range.step) !== '50') range.step = '50';
      if (+range.min !== min) range.min = String(min);
      if (+range.max !== max) range.max = String(max);
      var value = state.budget === null ? max : Math.min(Math.max(state.budget, min), top);
      if (+range.value !== value) range.value = String(value);
      range.style.setProperty('--fill', (max > min ? (value - min) / (max - min) * 100 : 100).toFixed(1) + '%');
      setText(root.querySelector('[data-budget-out]'), state.budget === null ? 'Any price' : 'Up to ' + money(state.budget * 100));
      range.setAttribute('aria-valuetext', state.budget === null ? 'Any price' : 'Up to ' + money(state.budget * 100));
    }

    function placeCursors() {
      all('.mo-lineup__seg', root).forEach(function (group) {
        var on = group.querySelector('[aria-pressed="true"]'), cursor = group.querySelector('.mo-lineup__cursor');
        if (!on || !cursor || !on.offsetWidth) return;
        if (!cursor.hasAttribute('data-placed')) {
          cursor.setAttribute('data-placed', '');
          cursor.style.transition = 'none';
          requestAnimationFrame(function () { requestAnimationFrame(function () { cursor.style.transition = ''; }); });
        }
        cursor.style.width = on.offsetWidth + 'px';
        cursor.style.transform = 'translateX(' + on.offsetLeft + 'px)';
      });
    }

    var receipt = null;
    function goTo(id) {
      var row = rows.filter(function (x) { return x.id === String(id); })[0];
      if (!row || row.el.hidden) return;
      /* to the top of the window's clear area (the page's scroll padding keeps the header and size bar off it);
         'auto' would follow the theme's smooth scrolling, so reduced motion asks for 'instant' */
      row.el.scrollIntoView({ behavior: still ? 'instant' : 'smooth', block: 'start' });
      row.el.classList.remove('is-hit');
      void row.el.offsetWidth;
      row.el.classList.add('is-hit');
      setTimeout(function () { row.el.classList.remove('is-hit'); }, 1700);
      var link = row.el.querySelector('.mo-lineup__name a');
      if (link) link.focus({ preventScroll: true });
    }

    function update() {
      var store = selectedStore();
      budgetBounds();
      var shown = [], low = 0, high = 0, off = 0;
      rows.forEach(function (row) {
        var r = read(row);
        row.r = r;
        var visible = passes(row, r);
        if (row.el.hidden === visible) row.el.hidden = !visible;
        if (visible) shown.push(row);

        row.el.classList.toggle('is-off', r.group === 0);
        if (row.el.getAttribute('data-group') !== String(r.group)) row.el.setAttribute('data-group', String(r.group));
        row.buy.classList.toggle('is-none', !r.entry);
        setPrice(row, row.buy.querySelector('[data-now]'), r.entry);
        var cmp = row.buy.querySelector('[data-cmp]');
        if (cmp.hidden === r.struck) cmp.hidden = !r.struck;
        setText(cmp.querySelector('[data-cmp-label]'), r.struck ? row.label : '');
        setText(cmp.querySelector('[data-was]'), r.struck ? money(r.entry.compare) : '');
        setText(row.buy.querySelector('[data-diff]'), r.diff > 0 ? money(r.diff) + ' less' : '');
        setText(row.buy.querySelector('[data-tag]'), r.entry && !r.ok ? (r.entry.name != null ? 'Sold out' : 'Sold out in ' + state.size) : '');
        setText(row.buy.querySelector('[data-for]'), r.ok ? (r.entry.name != null ? r.entry.name : state.size) : '');
        aimEta(row, r);
        floorWording(row);

        if (visible && r.ok) {
          if (!low || r.entry.price < low) low = r.entry.price;
          if (r.entry.price > high) high = r.entry.price;
        } else if (visible && r.entry) off++;
      });

      /* largest difference first, then price only by price, then what cannot be bought in this size */
      shown.sort(function (a, b) {
        if (a.r.group !== b.r.group) return b.r.group - a.r.group;
        if (a.r.diff !== b.r.diff) return b.r.diff - a.r.diff;
        var pa = a.r.entry ? a.r.entry.price : 1e12, pb = b.r.entry ? b.r.entry.price : 1e12;
        if (pa !== pb) return pa - pb;
        return a.index - b.index;
      });
      var hidden = rows.filter(function (row) { return row.el.hidden; });
      var firstPlain = shown.filter(function (row) { return row.r.group === 1; })[0] || null;
      var gone = shown.filter(function (row) { return row.r.group === 0; });
      var sold = gone.filter(function (row) { return row.r.entry; }).length, never = gone.length - sold;
      reorder(shown.concat(hidden), firstPlain, gone[0] || null, (sold && never ? 'Sold out or not made in ' : never ? 'Not made in ' : 'Sold out in ') + state.size);

      setText(root.querySelector('[data-count]'), shown.length + (shown.length === 1 ? ' bed' : ' beds'));
      var empty = root.querySelector('[data-empty]');
      if (empty && empty.hidden === !shown.length) empty.hidden = !!shown.length;

      all('[data-sizes] button', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-size') === state.size)); });
      all('[data-feels] button', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-feel') === state.feel)); });
      all('[data-brands] button', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-brand') === state.brand)); });
      var toggle = root.querySelector('[data-floor-only]');
      if (toggle) {
        toggle.setAttribute('aria-pressed', String(state.floorOnly));
        setText(toggle.querySelector('[data-floor-only-label]'), store && stores[store] ? 'On the floor in ' + storeName(store) : 'On showroom floors');
      }
      var active = (state.feel !== 'all') + (state.brand !== 'all') + (state.budget !== null) + (state.floorOnly ? 1 : 0);
      setText(root.querySelector('[data-filters-count]'), active ? ' (' + active + ')' : '');
      placeCursors();

      /* the receipt holds what the list holds, in the same order */
      var printable = shown.filter(function (row) { return row.r.group > 0; });
      var foot = printable.length + (printable.length === 1 ? ' bed' : ' beds') + ' priced for ' + state.size +
        (printable.length ? ', ' + money(low) + (high > low ? ' to ' + money(high) : '') : '') + '.' +
        (off ? ' ' + off + ' sold out in this size.' : '');
      var signature = state.size + '|' + off + '|' + printable.map(function (row) { return row.id; }).join(',');
      if (receipt && booted && signature !== update.last) {
        receipt.reprint(printable.map(function (row) {
          return {
            id: row.id, brand: row.brandName, name: row.name, plain: row.r.group === 1, label: row.label,
            now: money(row.r.entry.price), was: row.r.struck ? money(row.r.entry.compare) : '', diff: row.r.diff > 0 ? money(row.r.diff) : ''
          };
        }), { size: state.size, count: printable.length, word: printable.length === 1 ? 'bed' : 'beds', foot: foot, rest: restLabel });
      }
      update.last = signature;
      var aside = root.querySelector('[data-side]');
      if (aside && aside.getAttribute('aria-label') !== state.size + ' prices as a receipt') aside.setAttribute('aria-label', state.size + ' prices as a receipt');
    }

    function reset() {
      state.feel = 'all'; state.brand = 'all'; state.budget = null; state.floorOnly = false; update();
      /* the button that was pressed is hidden now: focus goes to the list's heading, right where it was */
      var head = root.querySelector('.mo-sale__list-head');
      if (head) { head.setAttribute('tabindex', '-1'); head.focus({ preventScroll: true }); }
    }

    root.addEventListener('click', function (e) {
      var size = e.target.closest('[data-size]');
      if (size && size.closest('[data-sizes]')) { state.size = size.getAttribute('data-size'); update(); return; }
      var feel = e.target.closest('[data-feel]');
      if (feel && feel.closest('[data-feels]')) { state.feel = feel.getAttribute('data-feel'); update(); return; }
      var brand = e.target.closest('[data-brand]');
      if (brand && brand.closest('[data-brands]')) { state.brand = brand.getAttribute('data-brand'); update(); return; }
      if (e.target.closest('[data-floor-only]')) { state.floorOnly = !state.floorOnly; update(); return; }
      if (e.target.closest('[data-reset]')) { reset(); return; }
      var more = e.target.closest('[data-filters-toggle]');
      if (more) {
        var box = root.querySelector('[data-filters]'), open = more.getAttribute('aria-expanded') !== 'true';
        more.setAttribute('aria-expanded', String(open));
        box.classList.toggle('is-open', open);
        placeCursors();
      }
    });
    if (range) {
      var live = function () {
        var top = +range.max - 50, value = +range.value;
        var text = value > top ? 'Any price' : 'Up to ' + money(value * 100);
        setText(root.querySelector('[data-budget-out]'), text);
        range.style.setProperty('--fill', ((value - range.min) / (range.max - range.min) * 100).toFixed(1) + '%');
      };
      range.addEventListener('input', live);
      range.addEventListener('change', function () {
        var top = +range.max - 50, value = +range.value;
        state.budget = value > top ? null : value;
        update();
      });
    }

    /* a bed scrolled to from the receipt must clear the size bar when that bar is pinned */
    function measure() {
      if (!controls) return;
      var h = getComputedStyle(controls).position === 'sticky' ? controls.offsetHeight : 0;
      if (root.__saleBar !== h) { root.__saleBar = h; root.style.setProperty('--sale-bar', h + 'px'); }
      fitReceipt();
      place();
      if (receipt && receipt.refit) receipt.refit();
    }

    var printer = root.querySelector('[data-receipt]');
    var side = root.querySelector('[data-side]'), listBox = root.querySelector('[data-sale-list]');
    /* Beside the list the collapsed receipt is pinned under the site header. The header's height
       changes with the window's width, so the number of lines that fit is measured: as many as
       fit, eight at most, three at least; with no room for three the receipt is not pinned. */
    var fitting = false;
    function fitReceipt() {
      var box = root.querySelector('[data-side]');
      if (!printer || !box || fitting) return;
      fitting = true;
      try { fitNow(box); } finally { setTimeout(function () { fitting = false; }, 0); }      /* its own attribute changes are not news */
    }
    function fitNow(box) {
      var css = getComputedStyle(box), pinned = css.position === 'sticky' || box.hasAttribute('data-free');
      if (css.position === 'sticky') root.__pinTop = parseFloat(css.top) || 0;
      var want = '', free = false;
      if (pinned && (printer.hasAttribute('data-collapsed') || printer.hasAttribute('data-short'))) {
        box.removeAttribute('data-free');
        /* It starts lower than it pins: beside the heading, under the header and the breadcrumbs.
           The whole printer should show on the first screen too, so that start is the limit. */
        var hero = root.querySelector('.mo-sale__hero');
        var start = Math.max(parseFloat(css.top) || 0, hero ? hero.getBoundingClientRect().top + window.pageYOffset : 0);
        var room = window.innerHeight - start - (printer.getBoundingClientRect().top - box.getBoundingClientRect().top) - 14, wasShort = printer.hasAttribute('data-short'), n;
        if (wasShort) { printer.removeAttribute('data-short'); printer.setAttribute('data-collapsed', ''); }
        for (n = 8; n >= 3; n--) {
          printer.setAttribute('data-lines', String(n));
          if (printer.offsetHeight <= room) break;
        }
        if (n < 3) {
          /* too short for the first screen: fit the pinned position, where the receipt spends its time */
          room += start - (parseFloat(css.top) || 0);
          for (n = 8; n >= 3; n--) {
            printer.setAttribute('data-lines', String(n));
            if (printer.offsetHeight <= room) break;
          }
        }
        if (n < 3) { n = 3; free = true; }
        want = String(n);
        if (wasShort) {
          printer.removeAttribute('data-collapsed'); printer.setAttribute('data-short', '');
          /* a short list is shown whole, footer and all: if that does not fit while pinned, it is not pinned */
          if (printer.offsetHeight > window.innerHeight - (parseFloat(css.top) || 0) - (printer.getBoundingClientRect().top - box.getBoundingClientRect().top) - 14) free = true;
        }
      }
      if (want) { if (printer.getAttribute('data-lines') !== want) printer.setAttribute('data-lines', want); }
      else if (printer.hasAttribute('data-lines')) printer.removeAttribute('data-lines');
      if (free !== box.hasAttribute('data-free')) { if (free) box.setAttribute('data-free', ''); else box.removeAttribute('data-free'); }
    }
    fitReceipt();
    /* "Print all" lets the receipt go: too tall to stay pinned. It is set down where it was pinned,
       so it prints beside the beds the shopper is looking at; rolled back, it pins again. */
    var opened = false;
    function place() {
      var box = root.querySelector('[data-side]');
      if (!printer || !box) return;
      var open = !printer.hasAttribute('data-collapsed') && !printer.hasAttribute('data-short');
      /* beside the list means pinned by the stylesheet (1240 px and up); stacked, the receipt stays where it is */
      var beside = getComputedStyle(box).gridColumnStart !== 'auto' && !!(window.matchMedia && window.matchMedia('(min-width: 1240px)').matches);
      if (open && beside && !opened) {
        box.style.marginTop = '';
        /* where it was pinned: read now, because the site header changes height once the page has scrolled */
        var natural = box.getBoundingClientRect().top + window.pageYOffset, pin = parseFloat(getComputedStyle(box).top);
        if (isNaN(pin)) pin = root.__pinTop || 0;
        var drop = Math.round(window.pageYOffset + pin - natural);
        if (drop > 0) box.style.marginTop = drop + 'px';
      } else if ((!open || !beside) && box.style.marginTop) box.style.marginTop = '';
      opened = open && beside;
    }
    if (printer && 'MutationObserver' in window) new MutationObserver(function () { if (fitting) return; fitReceipt(); place(); }).observe(printer, { attributes: true, attributeFilter: ['data-collapsed', 'data-short'] });
    /* the list sits under the receipt on phones and tablets, and beside it on wide screens */
    function under() { return side && listBox && side.getBoundingClientRect().bottom <= listBox.getBoundingClientRect().top + 2 ? [listBox] : []; }
    if (printer && window.MOSaleReceipt) receipt = window.MOSaleReceipt.mount(printer, { onLine: goTo, push: under });
    root.classList.add('is-live');
    update();
    measure();
    booted = true;
    window.addEventListener('load', function () { setTimeout(measure, 400); });
    return { update: update, placeCursors: placeCursors, measure: measure, state: state };
  }

  /* ---------- boot ---------- */
  var live = [];
  function boot(scope) {
    readStores();
    all('[data-mo-sale]', scope).forEach(function (root) {
      if (root.__moSale) return;
      root.__moSale = true;
      live.push({ root: root, board: Board(root) });
    });
  }
  function each(fn) { live = live.filter(function (x) { return document.documentElement.contains(x.root); }); live.forEach(fn); }

  window.MOSaleBoard = { boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('mo:showroom-change', function () { readStores(); each(function (x) { x.board.update(); }); });
  window.addEventListener('resize', function () { each(function (x) { x.board.placeCursors(); x.board.measure(); }); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { each(function (x) { x.board.placeCursors(); x.board.measure(); }); });

  /* prices roll to the new value with Number Flow (MIT, Maxwell Barvian), self-hosted in theme assets.
     Loaded as a module script element: Shopify's asset minifier rewrites a dynamic import() in a
     classic script into require(), which never runs. */
  var tag = document.querySelector('script[data-mo-sale-flow]');
  var src = tag && tag.getAttribute('data-mo-sale-flow');
  if (src && !still && window.customElements) {
    var loader = document.createElement('script');
    loader.type = 'module';
    loader.src = src;
    loader.onload = function () { if (customElements.get('number-flow')) flowReady = true; };
    document.head.appendChild(loader);
  }
})();
